import 'babel-polyfill'
// import 'es6-promise/auto'
import 'url-polyfill'
import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/scss/app.scss'
import './assets/js/script.js'
// import 'url-search-params-polyfill/index.js'
// import myConfig from './configfiles/config.json'
import myLanguage from './configfiles/locales/de_DE.json'
import Tabs from 'vue-tabs-component'
import BootstrapVue from 'bootstrap-vue'
import store from './store/store'
import Vuelidate from 'vuelidate'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueTagManager from 'vue-tag-manager'

// import { default as cwcc } from './assets/js/cwcc/index.js'
import { showSettings } from './assets/js/cwcc/utils.js'

// export default cwcc
window.showSettings = showSettings

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(Tabs)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueAxios, axios)

const i18n = new VueI18n({
  locale: 'de', // set locale
  messages: myLanguage, // set locale messages,
  silentTranslationWarn: true
})

Vue.use(VueTagManager, {
  gtmId: 'GTM-NWLQ7NC'
})

new Vue({
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')

// const cwccOpenBtns = document.getElementsByClassName('cwcc-open-settings')
// for (let i = 0; i < cwccOpenBtns.length; i++) {
//   const cwccOpenBtn = cwccOpenBtns[i]
//   cwccOpenBtn.addEventListener('click', e => {
//     e.preventDefault()
//     showSettings()
//   })
// }
